import styled, { css } from 'styled-components';
import { Gray } from '../../../../constants/styles';
export const List = styled.ul `
  list-style: none;
`;
export const ListItem = styled.li `
  border-bottom: 1px solid ${Gray.x200};

  &:first-child {
    border-top: 1px solid ${Gray.x200};
  }
`;
const buttonStyles = css `
  background: none;
  border: none;
  display: flex;
  align-items: center;
  font-family: proxima-nova, Corbel, Arial, sans-serif;
  font-size: ${({ theme }) => theme.fontSizes.sizeMd1};
  color: ${({ theme }) => theme.colorsV2.font.textPrimary};
  justify-content: space-between;
  padding: 13px 0;
  width: 100%;
  line-height: 24px;
  text-decoration: none;
`;
export const Button = styled.button `
  ${buttonStyles}
`;
export const Link = styled.a `
  ${buttonStyles}
`;
export const SignUpSection = styled.div `
  display: flex;
  justify-content: flex-start;
  font-size: 18px;
  padding: 13px 0;
  width: 100%;
  line-height: 24px;
`;
export const SignUpParagraph = styled.p `
  margin-left: 10px;
`;
export const StyledLink = styled.a `
  color: ${({ theme }) => theme.colors.interactivePrimary01};
  font-weight: 600;
  width: unset;
  line-height: unset;
  text-decoration: none;
`;
export const NavigationLabel = styled.span `
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 0 4px;
`;
//# sourceMappingURL=MobileNavigation.styled.js.map